import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=219b6aa5&scoped=true"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b6aa5",
  null
  
)

export default component.exports